export enum typePresence {
  Obbligatorio = 'O', // Sempre PRESENTE e sempre OBBLIGATORIO
  Facoltativo = 'F', // Sempre PRESENTE e OBBLIGATORIO se viene inserito qualche campo
  Condizionato = 'C', // PRESENTE solo se attivato da un terzo campo in un altro accordion ed allo stesso tempo diventa anche OBBLIGATORIO
  Default1 = 'D1', // Sempre PRESENTE e compilazione NON OBBLIGATORIA ma se non salvato nulla alcuni campi vengono mandati di DEFAULT
  FacoltativoObbligatorio = 'FO', // Sempre PRESENTE e OBBLIGATORIO se viene inserito qualche campo o se CONDIZIONATO da un terzo campo
}

export const idAgeDefectDefault = '002'; // per idAgeDefect !== 1
export const idRelationshipDefault = '001'; // per idRelationship !== 0
export const idTemporaryBanRemarriageDefault = '999'; // per idTemporaryBanRemarriage che è un booleano
export const idOppositionDefault = '01OPP'; // per conflitto con stesso valore
export const idOpposition2Default = '02OPP'; // per conflitto con stesso valore
export const idMunicipalityDifferentMilano = 'M01'; // per isMunicipalityDifferentMilano che è un booleano
